import { ProductPageLayout } from '../components/ProductPageLayout';

export function ChatgptPlusPage() {
    return <ProductPageLayout productId="chatgpt-plus" />;
}
